module.exports = __webpack_public_path__ + "img/album07_01.8cd28357.jpg";